(function () {
  if (new URLSearchParams(window.location.search).get('open_cart') !== 'true') return;

  // Clean the URL without reloading
  var newUrl = window.location.pathname + window.location.search
    .replace(/[?&]open_cart=true/, '')
    .replace(/^&/, '?');
  window.history.replaceState(null, '', newUrl || window.location.pathname);

  // Click the cart drawer toggle
  function tryOpenCart(attempt) {
    var toggle = document.getElementById('cart-drawer-toggle');
    if (toggle) {
      toggle.click();
      return;
    }
    if (attempt < 15) {
      setTimeout(function () { tryOpenCart(attempt + 1); }, 300);
    }
  }

  // Wait 800ms after page load before first attempt
  // This gives the theme JS time to initialize the cart drawer
  function startWithDelay() {
    setTimeout(function () { tryOpenCart(0); }, 800);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', startWithDelay);
  } else {
    startWithDelay();
  }
})();